import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux'
import {DeleteOutline} from '@material-ui/icons';
import './rglCss/styles.css'
import CustomScrollbars from 'util/CustomScrollbars';
import {IconButton, Paper, withStyles,  Tooltip,Grid,Button} from '@material-ui/core';
import {getCustomLobby, onSaveThisLobby, updateUserFlags ,getUser} from 'actions'
import __data from './Widgets/data'
import moment from 'moment-timezone';
import _, { isNull,isUndefined,isEmpty } from "lodash";
import Header from './Header'
import {Responsive,  WidthProvider} from 'react-grid-layout'
import { v4 as uuidv4 } from 'uuid';
import Widgets from './Widgets'
import WidgetSettings from './PopUps/WidgetSettings'
import IntlMessages from 'util/IntlMessages';
import ProjectBoards from './Widgets/ProjectBoards'
import PopUpSkapaTidsrapport from '../../../SkapaTidsrapport/PopUpSkapaTidsrapport';

const gridGap = 15

const styles = theme => ({
    //{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 },
    gridbgLg2: {
      position: 'absolute',
      display: 'grid',
      zIndex: 0,
      bottom: 0,
      top: 50,
      gap: gridGap,
      gridTemplateColumns: 'repeat(12, 1fr);',
      gridAutoRows: '40px',
      padding: gridGap,
      width:1280,
      overflow: 'scroll',
    },
    gridbgLg: {
      display: 'grid',
      position: 'absolute',
      zIndex: 0,
      left: 0,
      right: 0,
      bottom: 0,
      top: 50,
      gap: gridGap,
      gridTemplateColumns: 'repeat(12, 1fr);',
      gridAutoRows: '40px',
      padding: gridGap,
      minWidth:1200,
      // overflow: 'hidden',
      height: 'calc(100% - 60px)'
    },
    gridbgMd2: {
      position: 'absolute',
      display: 'grid',
      zIndex: 0,
      bottom: 0,
      top: 50,
      gap: gridGap,
      gridTemplateColumns: 'repeat(10, 1fr);',
      gridAutoRows: '40px',
      padding: gridGap,
      width:1024,
      overflow: 'scroll'
    },
    gridbgMd: {
      display: 'grid',
      position: 'absolute',
      zIndex: 0,
      left: 0,
      right: 0,
      bottom: 0,
      top: 50,
      gap: gridGap,
      gridTemplateColumns: 'repeat(10, 1fr);',
      gridAutoRows: '40px',
      padding: gridGap,
      minWidth:996,
      // overflow: 'hidden',
      height: 'calc(100% - 60px)'
    },
    gridbgSm: {
      display: 'grid',
      position: 'absolute',
      zIndex: 0,
      left: 0,
      right: 0,
      bottom: 0,
      top: 50,
      gap: gridGap,
      gridTemplateColumns: 'repeat(6, 1fr);',
      gridAutoRows: '40px',
      padding: gridGap,
      width:768,
      // overflow: 'hidden',
      height: 'calc(100% - 60px)'
    },
    gridbgSm2: {
      position: 'absolute',
      display: 'grid',
      zIndex: 0,
      bottom: 0,
      top: 50,
      gap: gridGap,
      gridTemplateColumns: 'repeat(6, 1fr);',
      gridAutoRows: '40px',
      padding: gridGap,
      width:768,
      overflow: 'scroll',
    },
    gridbgXs: {
      display: 'grid',
      position: 'absolute',
      zIndex: 0,
      left: 0,
      right: 0,
      bottom: 0,
      top: 50,
      gap: gridGap,
      gridTemplateColumns: 'repeat(4, 1fr);',
      gridAutoRows: '40px',
      width:480,
      padding: gridGap,
      height: 'calc(100% - 60px)'      
    },
    gridbgXs2: {
      position: 'absolute',
      display: 'grid',
      zIndex: 0,
      bottom: 0,
      top: 50,
      gap: gridGap,
      gridTemplateColumns: 'repeat(2, 1fr);',
      gridAutoRows: '40px',
      width:320,
      padding: gridGap,
      overflow: 'scroll',    
    },
    gridbgXss: {
      display: 'grid',
      position: 'absolute',
      zIndex: 0,
      left: 0,
      right: 0,
      bottom: 0,
      top: 50,
      gap: gridGap,
      gridTemplateColumns: 'repeat(2, 1fr);',
      gridAutoRows: '40px',
      padding: gridGap,
    },
    gridBgItem: {
      backgroundColor: '#b0b0b033',
      borderRadius: 20
    }
});
const ResponsiveReactGridLayout = WidthProvider(Responsive);
function mapStateToProps({auth,accountsData, DashBoard, userData}) {
    const {authUser} = auth
    const {user} = userData
    const {currentAccount, Flags} = accountsData
    const {MyLobby} = DashBoard
    return {
      authUser, currentAccount, Flags,MyLobby,user
    };
}
function mapDispatchToProps(dispatch) {
    return {
      getCustomLobby: (Userid, Afid) => dispatch(getCustomLobby(Userid, Afid)),
      onSaveThisLobby:(Userid, Afid,Layouts,layoutData) => dispatch(onSaveThisLobby(Userid,Afid,Layouts,layoutData)),
      updateUserFlags:(userid,Afid,user,Meta,Value) => dispatch(updateUserFlags(userid,Afid,user,Meta,Value)),
      getUser:(userid,Afid) => dispatch(getUser(userid,Afid)),
      dispatch
    };
  }
const cols = { lg: 12, md: 10, sm: 6, xs: 2, }
const col2s = { lg: 12, md: 6, sm: 4, xs: 2, }
const breakpoints = { lg: 1280, md: 1024, sm: 768, xs: 320,}
const breakpoints1 = { lg: "100%", md: "100%", sm: "100%", xs: "100%",}
const devices = ['mobile', 'tablet', 'laptop', 'desktop'];

class ExtraLargeGridList extends Component {

		setInitBreakpoint(){
			if(window.innerWidth > 1400) return 'lg'
			if(window.innerWidth > 1150) return 'md'
			if(window.innerWidth > 768) return 'sm'
			return 'xs'
		}

    constructor(props) {
        super(props);
        this.gridRef = null;
        this.state = {
          selectedDevice:"",
          currentBreakpoint: this.setInitBreakpoint(),
          compactType: 'vertical',
          mounted: false,
          layouts: { lg: generateLayout([]).layout,md:generateLayout([]).layout,sm:generateLayout([]).layout,xs:generateLayout([]).layout, },
          //MyLobby:this.props.MyLobby,
          editing: false,
          settingsOpen: false,
          layoutData: [],
          addWidgetDrawerOpen: false,
					LobbyPreset: 'initial',
					skapatidsrapportopen:false
        };
        this.setAddWidgetDrawer = this.setAddWidgetDrawer.bind(this) 
        this.onSetEditing = this.onSetEditing.bind(this)
        this.onHandleChangeLobbyPreset = this.onHandleChangeLobbyPreset.bind(this)
        this.addBlocks = this.addBlocks.bind(this)
        this.getColCount = this.getColCount.bind(this)
        this.onBreakpointChange = this.onBreakpointChange.bind(this)
        this.onLayoutChange = this.onLayoutChange.bind(this)
        this.removeBlock = this.removeBlock.bind(this)
        this.handleUpdateBlock = this.handleUpdateBlock.bind(this)
        this.generateDOM = this.generateDOM.bind(this)
        this.getLayoutPreset = this.getLayoutPreset.bind(this)
        this.getDeviceStyles  = this.getDeviceStyles.bind(this)
        this.getselectedDevice  = this.getselectedDevice.bind(this)
        this.getIntervalTypeText = this.getIntervalTypeText.bind(this)
    		this.getMainValueText = this.getMainValueText.bind(this)
    }
    getDeviceStyles (device){
      console.log(device,"Editing $$$$")

			if(!this.state.editing) return { width: '100%', margin: '0px'}
      switch (device) {
        case 'mobile':
          return { width: '321px', height: '568px', margin: '0px' };
        case 'tablet':
          return { width: '769px', height: '1024px', margin: '0px' };
        case 'laptop':
          return { width: '1025px', height: '768px', margin: '0px' };
        default:
          return { width: '100%', margin: '0px'}; // Handle unexpected device types gracefully
      }
    }
    getIntervalTypeText(type) {
      switch(type) {
        case 1: return String(moment().format('MMMM')).charAt(0).toUpperCase() + String(moment().format('MMMM')).slice(1)
        case 2: return moment().format('YYYY')
        case 3: return String(moment().format('dddd')).charAt(0).toUpperCase() + String(moment().format('dddd')).slice(1)
        case 4: return `V ${moment().format('WW')}`
        default: return ''
      }
    }
		getMainValueText(type) {
			const returnMainValueInNotyfile=()=>{
				switch(this.props.Flags.ValueInNotyfile){
					case 0:return  <>&nbsp;(<IntlMessages id="input.TB"/>)</>
					case 1:return <>&nbsp;(<IntlMessages id="input.Utpris"/>)</>
					case 2:return <>&nbsp;(<IntlMessages id="Company.Total"/>)</>
					default: return ''
				}
			}
			switch(type) {
				case 'Utpris': return <>&nbsp;(<IntlMessages id="input.Utpris"/>)</>
				case 'TB': return  <>&nbsp;(<IntlMessages id="input.TB"/>)</>
				default: return returnMainValueInNotyfile()
			}
		}

		getLayoutPreset() {
			console.log(this.state, 'sstatetet')
			if(this.state.LobbyPreset === "project-time"){
				const dataLg = [
					{
						i:"0",
						id:"0",
						blockX: 7,
						blockY: 0,
						blockW: 4,
						blockH: 1,
						x: 1,
						y: 0,
						w: 4,
						h: 1,
						type: 1001,
						transparent: true,
					},
					{
						i:"1",
						id:"1",
						blockX: 7,
						blockY: 1,
						blockW: 4,
						blockH: 10,
						x: 7,
						y: 1,
						w: 4,
						h: 10,
						type: 406,
					},
					{
						i:"2",
						id:"2",
						blockX: 1,
						blockY: 0,
						blockW: 6,
						blockH: 16,
						x: 1,
						y: 0,
						w: 6,
						h: 12,
						type: 1002,
						transparent: true,
					}
				]
				const dataSm = [
					{
						i:"0",
						id:"0",
						blockX: 0,
						blockY: 0,
						blockW: 12,
						blockH: 1,
						x: 0,
						y: 0,
						w: 12,
						h: 1,
						type: 1001,
						transparent: true,
					},
					{
						i:"1",
						id:"1",
						blockX: 0,
						blockY: 0,
						blockW: 12,
						blockH: 8,
						x: 0,
						y: 0,
						w: 12,
						h: 8,
						type: 406,
					},
					{
						i:"2",
						id:"2",
						blockX: 0,
						blockY: 9,
						blockW: 12,
						blockH: 16,
						x: 0,
						y: 9,
						w: 12,
						h: 12,
						type: 1002,
						transparent: true,
					}
				]
				return {
          layouts: { lg: generateLayout(dataLg).layout,md:generateLayout(dataSm).layout,sm:generateLayout(dataSm).layout,xs:generateLayout(dataSm).layout, },
					layoutData: dataLg
				}
			}
			return {layouts: this.state.layouts, layoutData: this.state.layoutData}
		}

    generateDOM() {


      const editing = this.state.editing
      return this.getLayoutPreset().layouts[this.state.currentBreakpoint].map((l) => {

        let thisBlock = this.getLayoutPreset().layoutData.find(d => d.i === l.i)

        thisBlock = {...thisBlock,
          w: l.w, 
          h: l.h, 
          x: l.x, 
          y: l.y
        }

				if(thisBlock.type === 400){
					thisBlock.transparent = true
				}
				let item = __data.find(d => d.type === thisBlock.type)
			
				if(!item) return 

        return (
          <Paper 
            data-grid={{
              x: l.x, y: l.y, w: l.w, h: l.h
            }}
            key={l.i} 
            className={(this.state.editing || thisBlock.transparent) && 'shadow-none'} 
            style={{backgroundColor: thisBlock.transparent ? 'transparent' :isUndefined(thisBlock.BackGroudColor)?'#FFFFFF':thisBlock.BackGroudColor, position: 'relative',
             overflow: 'hidden', borderRadius: 20, boxShadow: '0 4px 6px rgba(47, 43, 61, 0.05),0 0 transparent,0 0 transparent'}}
            >
          
            {
              editing &&
              <div style={{position: 'absolute', right:0, top: 0, zIndex:100,background: '#f4f4f4',borderRadius:"0px 0px 0px 10px"}} className="d-flex align-items-center"
              onMouseDown={e => e.stopPropagation()}
            onTouchStart={e => e.stopPropagation()}
            onClick={e => e.stopPropagation()}
              >
                <WidgetSettings  setOpen={o => this.setState(s => ({...s, settingsOpen: o}))} {...thisBlock} updateDateBlock={(block) => this.handleUpdateBlock(block, l.i)}/>
                <Tooltip title={<IntlMessages id="Remove"/>}>
                  <IconButton onClick={() => this.removeBlock(l.i)} size="small" color="secondary">
                    <DeleteOutline/>
                  </IconButton>
                </Tooltip>
              </div>
            }
            {l.static ? (
              <span
                className="text"
                title="This item is static and cannot be removed or resized."
              >
                Static - {l.i}
              </span>
            ) : (
              editing === true?
              <Widgets editing={editing} isFrom={1} getMainValueText={this.getMainValueText} getIntervalTypeText={this.getIntervalTypeText} Flags={this.props.Flags} {...thisBlock}/>
              :
              <Widgets editing={editing} getMainValueText={this.getMainValueText} getIntervalTypeText={this.getIntervalTypeText} Flags={this.props.Flags} {...thisBlock}/>
            )}
          </Paper>
        );
      });
    }

    onLayoutChange(layout) {
			if(this.state.LobbyPreset === "custom" && this.state.editing){
				this.setState(s => ({
					layouts: {
						...s.layouts,
						[s.currentBreakpoint]: layout}
				}))
			}
    }
    getselectedDevice(breakpoint){
      switch(breakpoint){
        case "lg":return "desktop"
        case "md":return "laptop"
        case "sm":return "tablet"
        case "xs":return "mobile"
        default:return ""
      }
    }
    onBreakpointChange(breakpoint) {
			console.log('breakpointChange', breakpoint)
      this.setState(s => ({
				...s,
        selectedDevice:isNull(breakpoint)?"":breakpoint ==='lg'?"":this.getselectedDevice(breakpoint),
        currentBreakpoint: isNull(breakpoint) ? s.currentBreakpoint : breakpoint,
      }));
    };
    removeBlock(index) {
      console.log('Editing1', index)
      let newLayout = [...this.state.layouts[this.state.currentBreakpoint]]
      let newLayoutData = [...this.state.layoutData]
      
      newLayout = newLayout.filter(l => l.i !== index)
      newLayoutData = newLayoutData.filter(l => l.i !== index)
  
      console.log('Editing1', newLayout)
      this.setState(s => ({
				...s,
        layouts: {
          ...s.layouts,
          [s.currentBreakpoint]: newLayout
        },
        layoutData: newLayoutData
      }))
    }
    handleUpdateBlock(block, index) {
      let newLayoutData = [...this.state.layoutData]
      
      newLayoutData = newLayoutData.filter(l => l.i !== index)
      newLayoutData.splice(index, 0, block)
      this.setState(s => ({
				...s,
        layoutData: newLayoutData
      }))
    }
  
		componentWillUnmount() {
			// Clean up event listeners
			document.removeEventListener('gesturestart', this.preventZoom);
			document.removeEventListener('gesturechange', this.preventZoom);
			document.removeEventListener('gestureend', this.preventZoom);
			window.removeEventListener('wheel', this.preventScrollZoom);
		}
		preventZoom = (e) => {
			e.preventDefault();
		};
		
		preventScrollZoom = (e) => {
			if (e.ctrlKey) {
				e.preventDefault();
			}
		};
		
		mapLayoutWithWidgetData = (layout, layoutData)=> {
			let returnLayout = {}
			Object.keys(layout).map(bp =>{
				returnLayout[bp] = layout[bp].map(b =>{

        	let thisBlock = layoutData.find(d => d.i === b.i)
					console.log(thisBlock.type,'sdlkfskdjfsdf')
					if(!thisBlock) return b

          let thisType = __data.find(d => d.type === thisBlock.type)
					if(!thisType) return b

					return {
						...b,
            maxW: isUndefined(thisType)?b.maxW:thisType.maxW,
            minW: isUndefined(thisType)?b.minW:thisType.minW,
            maxH: isUndefined(thisType)?b.maxH:parseInt(thisType.type) === 400 || parseInt(thisType.type) === 402?Infinity: thisType.maxH,
            minH: isUndefined(thisType)?b.minH:thisType.minH,
					}
				})
			})
			return returnLayout
		}

    componentDidMount(){
			this.props.getUser(this.props.authUser.user_id, this.props.authUser.user_Afid)
      document.addEventListener('gesturestart', this.preventZoom);
      document.addEventListener('gesturechange', this.preventZoom);
      document.addEventListener('gestureend', this.preventZoom);
      window.addEventListener('wheel', this.preventScrollZoom, { passive: false });

      if(isEmpty(this.props.MyLobby)){
        this.props.getCustomLobby(this.props.authUser.user_id,this.props.authUser.user_Afid)  
      } else {
				this.setState(s => ({
					...s,
					MyLobby:this.props.MyLobby,
					layoutData: JSON.parse(this.props.MyLobby[0].layoutData),
					layouts: this.mapLayoutWithWidgetData(JSON.parse(this.props.MyLobby[0].LobbyObj), JSON.parse(this.props.MyLobby[0].layoutData)),
				}))    
      }

    }
    componentDidUpdate(prevProps, prevState) {
				
			if(this.state.LobbyPreset === "initial" && !isUndefined(this.props.user?.LobbyPreset)){
				this.setState(s => ({...s, LobbyPreset: this.props.user?.LobbyPreset}))
			}
      if(this.props.MyLobby !== prevProps.MyLobby){

				if(isUndefined(this.state.MyLobby)){

					if(JSON.parse(this.props.MyLobby[0].LobbyObj) !== this.state.layouts){

						this.setState(s => ({
							...s,
							MyLobby:this.props.MyLobby,
							layoutData: JSON.parse(this.props.MyLobby[0].layoutData),
							layouts: this.mapLayoutWithWidgetData(JSON.parse(this.props.MyLobby[0].LobbyObj), JSON.parse(this.props.MyLobby[0].layoutData)),
						}))
					}

				}
    	}
    }
    getColCount() {
      const {classes} = this.props  
      // { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }
      switch(this.state.currentBreakpoint) {
        case 'lg': return classes.gridbgLg
        case 'md':return classes.gridbgMd
        case 'sm':return classes.gridbgSm
        case 'xs':return classes.gridbgXs
        default: return classes.gridbgLg
      }
    }
    getColCount1() {
      const {classes} = this.props  
      // { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }
      switch(this.state.currentBreakpoint) {
        case 'lg': return classes.gridbgLg
        case 'md':return classes.gridbgMd2
        case 'sm':return classes.gridbgSm2
        case 'xs':return classes.gridbgXs2
        default: return classes.gridbgLg
      }
    }
    setAddWidgetDrawer(open) {
        this.setState(s => ({...s, addWidgetDrawerOpen:open}))
    }
    onSetEditing() {
      if(this.state.editing === true){
        //save this.layout
        this.props.onSaveThisLobby(this.props.authUser.user_id,this.props.authUser.user_Afid,this.state.layouts,this.state.layoutData)
      }
      this.setState(s => ({
				...s,
				selectedDevice: this.state.editing ? null : this.getselectedDevice(s.currentBreakpoint),
				currentBreakpoint: this.state.editing ? this.setInitBreakpoint() : s.currentBreakpoint, 
        editing: !this.state.editing
      }))
    }
    onHandleChangeLobbyPreset(value, user) {
			this.props.updateUserFlags(this.props.authUser.user_id,this.props.authUser.user_Afid,{...user, LobbyPreset: value},'LobbyPreset',value)
      this.setState(s => ({
				...s,
        LobbyPreset: value 
      }))
    }
   
      addBlocks(blocks) {
        let newBlocks = []
        let newLdata = []
        for(let b of blocks) {
          let sortedArr = [...this.state.layouts[this.state.currentBreakpoint], ...newBlocks].sort((a,b) => parseInt(a.i) - parseInt(b.i))
          //let newI = _.isEmpty([...this.state.layouts[this.state.currentBreakpoint], ...newBlocks]) ? "0" : (parseInt(sortedArr[(this.state.layouts[this.state.currentBreakpoint].length + newBlocks.length-1)].i) + 1).toString()
          let newI = uuidv4()
          let thisType = __data.find(d => d.type === b.type)
          let tagStateKey = String('TopTags'+uuidv4()).replace(/-/g,'')
          let newBlock = {
            x: 0,
            y: 0,
            w: isUndefined(thisType)?2:thisType.minW,
            h:  isUndefined(thisType)?4:thisType.minH,
            i: newI,
            maxW: isUndefined(thisType)?undefined:thisType.maxW,
            minW: isUndefined(thisType)?undefined:thisType.minW,
            maxH: isUndefined(thisType)?undefined:parseInt(thisType.type) === 400 || parseInt(thisType.type) === 402?Infinity: thisType.maxH,
            minH: isUndefined(thisType)?undefined:thisType.minH,
            static: false,
            resizeHandles:['se'],
          }
          newBlocks.push(newBlock)
          newLdata.push({
            ...newBlock,
            type: b.type, 
            tagStateKey: b.type === 32 ? tagStateKey : null,
            tagsJSON: '[]',
            usersJSON: '[]',
            startDate: null,
						orderVardeSetting: this.props.Flags.OrderVardeStandard,
            abonnamangeSetting: this.props.Flags.AbonemangeStandard,
            text: b.type === 32 ? 'Topplista taggar' : 'Text123',
            textSize: 22, 
            BackGroudColor:parseInt(thisType.type) === 400 || parseInt(thisType.type) === 402?'#FFFFFF00':'#FFFFFF',
            ImageHeight:50,
            chartType:"",
            title:"",
            hAxis:"",
            vAxis:"",
            TavlingList:"",
            FontColor:'#000',
            countStart: moment(), 
            countEnd: moment(), 
            intervaltype:1,
            typeoptiongrowth:1,
            daysForward: 0,
            daysBackward: 0,
            i: newI
          })
        }
        
        this.setState(s => ({
					...s,
          layouts: {
            ...this.state.layouts,
            [this.state.currentBreakpoint]: [...this.state.layouts[this.state.currentBreakpoint], ...newBlocks]
          },
          layoutData: [...this.state.layoutData, ...newLdata]
        }))
      }
    calculateWidth = () => {
      const width = breakpoints[this.state.currentBreakpoint];
      return width ? `${width}px` : '100%'; // Default to 100% if width is not found
    }
    render() {
        const {classes} = this.props
        return (
            <>            
                <CustomScrollbars className="module-list-scroll scrollbar"
                style={{ 
                    //height:'Calc(100vh - 98px)',
                    height:'Calc(100vh - 60px)',
                    }}>
                      <Header 
											LobbyPreset={this.state.LobbyPreset}
											onHandleChangeLobbyPreset={this.onHandleChangeLobbyPreset}
                      onSetEditing={this.onSetEditing} 
                      editing={this.state.editing}   
                      addBlocks={this.addBlocks}   
                      layout={this.state.currentBreakpoint}    
                      onHandleChange={this.onBreakpointChange}    
                      />
                      {
                        this.state.selectedDevice !==""?
                        <Grid
                        container
                        direction="row"
                        style={{  justifyContent: "center"}}
                        alignItems="center"
                        >
                          <div
                          style={this.getDeviceStyles(this.state.selectedDevice)}
                          >
                             {
                        this.state.editing && this.gridRef &&
                        <div>
                        <div className={this.getColCount1()}>
                        {
                        _.map(new Array((parseInt(this.gridRef.getBoundingClientRect().height / 50) * parseInt(cols[this.state.currentBreakpoint])) < parseInt((window.innerHeight-100)/50) * parseInt(cols[this.state.currentBreakpoint]) ?

                          parseInt((window.innerHeight-100)/50) * parseInt(cols[this.state.currentBreakpoint]) : 

                          (parseInt(this.gridRef.getBoundingClientRect().height / 50) * parseInt(cols[this.state.currentBreakpoint]))
                        ), (i) => <div className={classes.gridBgItem}
                          style={{width:'100%'}}
                          ></div>)}
                        </div>
                        </div>
                      }    
                             <ResponsiveReactGridLayout
                      {...this.props}
											margin={[gridGap, gridGap]}
											key={`${this.state.currentBreakpoint}-${this.state.selectedDevice}-${this.state.editing ? '1': '0'}`}
                      ref={(ref) => {
                        if(!_.isNull(ref)){
                          this.gridRef = ref.elementRef.current
                          console.log(this.gridRef)
                        } 
                      }}
                      width={breakpoints[this.state.currentBreakpoint]}
                      layouts={this.state.LobbyPreset === 'initial' ? [] : this.getLayoutPreset().layouts}
                      rowHeight={40}
                      breakpoints={breakpoints}
                      cols={cols}
                      onBreakpointChange={this.onBreakpointChange}
                      onLayoutChange={this.onLayoutChange}
                      onDrop={this.onDrop}
                      isDraggable={this.state.editing && !this.state.settingsOpen}
                      isResizable={this.state.editing && !this.state.settingsOpen}
                      useCSSTransforms={true}
											// measureBeforeMount={true}
                      compactType={this.state.compactType}
                      preventCollision={!this.state.compactType}
                      >
                        {
                        this.state.LobbyPreset !== 'initial' && this.generateDOM()
                        }
                      </ResponsiveReactGridLayout>
                          </div>
                        </Grid>
                       : 
                       <>
                        {
                        this.state.editing && this.gridRef &&
                        <div>
                        <div className={this.getColCount1()}>
                        {
                        _.map(new Array((parseInt(this.gridRef.getBoundingClientRect().height / 50) * parseInt(cols[this.state.currentBreakpoint])) < parseInt((window.innerHeight-100)/50) * parseInt(cols[this.state.currentBreakpoint]) ?

                          parseInt((window.innerHeight-100)/50) * parseInt(cols[this.state.currentBreakpoint]) : 

                          (parseInt(this.gridRef.getBoundingClientRect().height / 50) * parseInt(cols[this.state.currentBreakpoint]))
                        ), (i) => <div className={classes.gridBgItem}
                          style={{width:'100%'}}
                          ></div>)}
                        </div>
                        </div>
                      }    
                      <ResponsiveReactGridLayout
                      {...this.props}
											margin={[gridGap, gridGap]}
											key={`${this.state.currentBreakpoint}-${this.state.selectedDevice}-${this.state.editing ? '1': '0'}`}
                      ref={(ref) => {
                        if(!_.isNull(ref)){
                          this.gridRef = ref.elementRef.current
                          console.log(this.gridRef)
                        } 
                      }}
                      //width={breakpoints1[this.state.currentBreakpoint]}
                      layouts={this.state.LobbyPreset === 'initial' ? [] : this.getLayoutPreset().layouts}
                      rowHeight={40}
                      breakpoints={breakpoints}
                      cols={cols}
                      isFrom={1}
                      onBreakpointChange={this.onBreakpointChange}
                      onLayoutChange={this.onLayoutChange}
                      onDrop={this.onDrop}
                      isDraggable={this.state.editing && !this.state.settingsOpen}
                      isResizable={this.state.editing && !this.state.settingsOpen}
                      useCSSTransforms={true}
                      compactType={this.state.compactType}
											// measureBeforeMount={true}
                      preventCollision={!this.state.compactType}
                      >
                        {
                        this.state.LobbyPreset !== 'initial' && this.generateDOM()
                        }
                      </ResponsiveReactGridLayout>        
                      </>         
                    }   
                </CustomScrollbars>
            </>
        );
    }
}
function generateLayout(data) {

  let layout = _.map(data, (d, i) => {
    let thisType = __data.find(_d => _d.type === d.type)
    console.log(thisType,"Editing7")
    return {
      id: d.id,
      x: d.blockX,
      y: d.blockY,
      w: d.blockW,
      h: d.blockH,
      i: i.toString(),
      maxW: isUndefined(thisType)?undefined:thisType.maxW,
      minW: isUndefined(thisType)?undefined:thisType.minW,
      maxH: isUndefined(thisType)?undefined:parseInt(thisType.type) === 400 || parseInt(thisType.type) === 402?Infinity: thisType.maxH,
      minH: isUndefined(thisType)?undefined:thisType.minH,
      static: false,
      resizeHandles:['se']
    };
  });
  let _data  = _.map(data, (d, i) => {
    return {
      ...d,
      i: i.toString(),
    };
  });
  return {layout, data: _data}
}
export default compose(
    connect(
      mapStateToProps,
      mapDispatchToProps,
    ),
    withStyles(styles)
  )(ExtraLargeGridList);
